import styled from '@emotion/styled';
import { CircularProgress, Omit } from '@material-ui/core';
import Button, { ButtonProps } from '@material-ui/core/Button';
import React, { useState } from 'react';
import useIsMounted from '../../hooks/useIsMounted';

export type ButtonWithPromiseProps<T> = {
  onClick: (e: any) => Promise<T | void>;
  pending: React.ReactNode;
  noPropagation?: boolean;
} & Omit<ButtonProps, 'onClick'>;

export const ButtonLoader = styled(CircularProgress)`
  width: 20px !important;
  height: 20px !important;
  margin-right: ${(p) => p.theme.spacing(1)}px;

  svg {
    color: inherit;
  }
`;

export const ButtonWithPromise = <T extends any>(
  props: ButtonWithPromiseProps<T>
) => {
  const isMounted = useIsMounted();
  const [loading, setLoading] = useState(false);
  const {
    onClick,
    disabled,
    pending,
    children,
    startIcon,
    endIcon,
    noPropagation,
    ...other
  } = props;
  const done = () => isMounted.current && setLoading(false);
  const handleClick = (e: any) => {
    if (noPropagation) {
      e.stopPropagation();
      e.preventDefault();
    }
    setLoading(true);
    return onClick(e).then(done, done);
  };

  return (
    <Button
      {...other}
      disabled={disabled || loading}
      onClick={handleClick}
      startIcon={!loading && startIcon}
      endIcon={!loading && endIcon}
    >
      {loading ? (
        <>
          <ButtonLoader /> {pending}
        </>
      ) : (
        children
      )}
    </Button>
  );
};
